import { render, staticRenderFns } from "./Milestones.vue?vue&type=template&id=1488cb15&scoped=true&"
import script from "./Milestones.vue?vue&type=script&lang=js&"
export * from "./Milestones.vue?vue&type=script&lang=js&"
import style0 from "./Milestones.vue?vue&type=style&index=0&id=1488cb15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1488cb15",
  null
  
)

export default component.exports